<template>
  <div class="whitespace-nowrap flex items-center">
    <div
      v-for="(color, idx) in zoneColors"
      :key="idx"
      class="rounded-full mr-1"
      :class="[color, mini ? 'w-2 h-2' : 'w-5 h-5']"
    ></div>
  </div>
</template>

<script>
export default {
  props: {
    colors: {
      default: Array,
    },
    mini: {
      default: false,
    },
    inline: {
      default: false,
    },
  },

  computed: {
    zoneColors() {
      var colors = this.colors.split('-');

      var res = [];
      colors.forEach(function (color) {
        if (color == 'r') res.push('bg-red-500');
        if (color == 'y') res.push('bg-yellow-200');
        if (color == 'g') res.push('bg-green-500');
        if (color == 'b') res.push('bg-blue-500');
      });

      return res;
    },
  },
};
</script>